import { render, staticRenderFns } from "./operator-form-education.vue?vue&type=template&id=96004b80&lang=pug&"
import script from "./operator-form-education.vue?vue&type=script&lang=js&"
export * from "./operator-form-education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports